import React, { useEffect } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { useObjectSidebarActions } from '@confluence/object-sidebar-api/entry-points/useObjectSidebar.ts';

import { useWidthResizeObserver } from './useWidthResizeObserver.tsx';

// the min-width should match the value of MIN_PANEL_WIDTH from '@confluence/object-sidebar-api/entry-points/useObjectSidebar'
const panelPushStyles = xcss({
	display: 'block',
	minWidth: '400px',
});

export const ObjectSidebarPushPlaceholder = () => {
	const { setPanelWidth } = useObjectSidebarActions();
	const [containerRef, width] = useWidthResizeObserver();

	useEffect(() => {
		setPanelWidth(width);
	}, [width, setPanelWidth]);

	return <Box ref={containerRef} xcss={panelPushStyles} testId="object-sidebar-push-placeholder" />;
};
